export type BulkImportSource = 'empty' | 'files' | 'archive' | 'mixed';

type ImportFile = Pick<File, 'name'>;
type SizedImportFile = Pick<File, 'name' | 'size'>;

export const MAX_RESUME_UPLOAD_BYTES = 25 * 1024 * 1024;
export const MAX_ARCHIVE_UPLOAD_BYTES = 15 * 1024 * 1024 * 1024;

const isArchiveFileName = (name: string): boolean => {
  const lower = name.toLocaleLowerCase('ru-RU');
  return lower.endsWith('.zip') || lower.endsWith('.7z');
};

export const getBulkImportSource = (files: ImportFile[]): BulkImportSource => {
  if (files.length === 0) return 'empty';

  const archiveCount = files.filter((file) => isArchiveFileName(file.name)).length;
  if (archiveCount === 0) return 'files';
  return archiveCount === 1 && files.length === 1 ? 'archive' : 'mixed';
};

export const getImportFilesError = (
  files: SizedImportFile[],
  mode: 'single' | 'bulk',
): string | null => {
  for (const file of files) {
    if (isArchiveFileName(file.name)) {
      if (mode === 'single') return 'Архив можно загрузить только в массовом импорте';
      if (file.size > MAX_ARCHIVE_UPLOAD_BYTES) {
        return 'Архив больше 15 ГБ. Сожмите его или разбейте на несколько архивов.';
      }
      continue;
    }
    if (file.size > MAX_RESUME_UPLOAD_BYTES) {
      return `Файл «${file.name}» больше 25 МБ`;
    }
  }
  return null;
};
